// import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { useParams } from "react-router-dom";

import * as enums from "enumerations";
import * as Types from "Types";

import MoleculeNowContentsHeader from "Components/Molecules/NowContentsHeader";
import OrganismHeader from "Components/Organisms/Header";
import OrganismFooter from "Components/Organisms/Footer";
import OrganismNowContents from "Components/Organisms/NowContents";
import MoleculeKeywords from "Components/Molecules/Keywords";

export interface NowContentsProps extends Types.Default {
   nows: any;
}

dayjs.locale("ko");

// import * as Types from "Types";
const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;
const HeaderWrap = styled.div`
   display: flex;
   justify-content: center;
   width: 100%;
   padding: 0px 15px;
   border-bottom: 1px solid #000;
   box-sizing: border-box;
`;

const cssHeader = css`
   width: 100%;
   max-width: 1200px;
`;

const ChildNowContentsHeader = styled(MoleculeNowContentsHeader)`
   margin: 49px 0px 40px 0px;
`;

const Keywords = styled(MoleculeKeywords)`
   margin-top: 50px;
`;

const Footer = styled(OrganismFooter)`
   margin-top: 110px;
`;

export default function Nows(props: NowContentsProps) {
   // const width = useSelector(({ dimensions }: Types.State) => dimensions.width);

   const params = useParams();

   console.log("props", props);

   const contentHeaderProps =
      props.nows.status === enums.api.resolved
         ? {
              title: props.nows.data.title,
              subtitle: props.nows.data.subtitle,
              date: dayjs(props.nows.data.updated_datetime || props.nows.data.insert_datetime).format("YYYY-MM-DD"),
           }
         : {
              title: params.uriTitle,
              subtitle: props.nows.data.subtitle,
              date: dayjs().format("YYYY-MM-DD"),
           };
   return (
      <Wrap>
         {/* {styles.shows({ width, sizes: { s: false, xs: false } }) && <OrganismMenuList css={MenuCss}></OrganismMenuList>} */}
         <HeaderWrap>
            <OrganismHeader css={cssHeader}></OrganismHeader>
         </HeaderWrap>
         <ChildNowContentsHeader {...contentHeaderProps}></ChildNowContentsHeader>
         <OrganismNowContents></OrganismNowContents>
         <Keywords keywords={(props.nows.data.keywords || "").split(",")}></Keywords>
         <Footer></Footer>
      </Wrap>
   );
}
